"use strict";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCart = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var __1 = require("..");
var swr_1 = (0, tslib_1.__importDefault)(require("swr"));
function useCart(fetchOptions) {
    var _this = this;
    var url = '/cart';
    var fetch = (0, react_1.useCallback)(function (url) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
        var response;
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, __1.http.get({ url: url })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); }, []);
    var _a = (0, swr_1.default)(url, fetch, (0, tslib_1.__assign)({}, fetchOptions)), data = _a.data, error = _a.error, mutate = _a.mutate;
    var update = (0, react_1.useCallback)(function (items, shouldRevalidate) {
        if (shouldRevalidate === void 0) { shouldRevalidate = false; }
        return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var response;
            var _a;
            return (0, tslib_1.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        console.log('update called');
                        return [4 /*yield*/, __1.http.put({
                                url: url,
                                data: { items: items },
                            })];
                    case 1:
                        response = _b.sent();
                        if (!(data && mutate)) return [3 /*break*/, 3];
                        return [4 /*yield*/, mutate(items, shouldRevalidate)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/, (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.items];
                }
            });
        });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data]);
    var memoizedData = (0, react_1.useMemo)(function () { return ({
        items: data && data.items ? data.items : { products: [], events: [] },
    }); }, [data]);
    return {
        fetch: {
            data: memoizedData,
            error: error,
            mutate: mutate,
        },
        update: update,
    };
}
exports.useCart = useCart;
